/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopropertyOperationResponse
 */
export interface CopropertyOperationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyOperationResponse
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CopropertyOperationResponse
     */
    errorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyOperationResponse
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyOperationResponse
     */
    id?: string | null;
}

/**
 * Check if a given object implements the CopropertyOperationResponse interface.
 */
export function instanceOfCopropertyOperationResponse(value: object): value is CopropertyOperationResponse {
    return true;
}

export function CopropertyOperationResponseFromJSON(json: any): CopropertyOperationResponse {
    return CopropertyOperationResponseFromJSONTyped(json, false);
}

export function CopropertyOperationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyOperationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function CopropertyOperationResponseToJSON(json: any): CopropertyOperationResponse {
    return CopropertyOperationResponseToJSONTyped(json, false);
}

export function CopropertyOperationResponseToJSONTyped(value?: CopropertyOperationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorCode': value['errorCode'],
        'errorMessage': value['errorMessage'],
        'id': value['id'],
    };
}

